import { Translate } from '@chipinside/translate'
import { Box, Button, Grid, Tooltip } from '@mui/material'

import CowmedChip from '#/components/Chip'
import { Dialog } from '#/components/Dialog'
import { copyToClipboard } from '#/utils/copyToClipboard'

type Props = {
  values: string[]
}

export default function ImportUnrecognizedData({ values }: Props) {
  return (
    <Grid container spacing={2} columns={3} sx={{ flexWrap: 'wrap' }}>
      {values?.map(value => (
        <Grid size={{ md: 1, xs: 3 }}>
          <Tooltip title={Translate({ messageKey: 'copy' })}>
            <CowmedChip
              value={value}
              variant="soft"
              width="unset"
              onClick={() => copyToClipboard(value)}
            />
          </Tooltip>
        </Grid>
      ))}
      <Actions values={values} />
    </Grid>
  )
}

function Actions({ values }: Props) {
  const handleCopy = () => copyToClipboard(values?.join('\n'))

  const handleClose = () => Dialog.close()

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        gap: 2,
        justifyContent: 'flex-end',
        width: '100%',
      }}
    >
      <Button onClick={handleCopy} variant="outlined" size="small">
        {Translate({ messageKey: 'copy_all' })}
      </Button>
      <Button size="small" variant="contained" onClick={handleClose}>
        {Translate({ messageKey: 'close' })}
      </Button>
    </Box>
  )
}
